import { MfsStatusCode } from '@metaos/mfs-telemetry';
import { MfsFolderError } from './mfsFolderError';
/**
 * The exception that is thrown to indicate that an assertion has failed.
 *
 * @param message The message that will be returned to the user
 * @param eventName Identification of the event that triggered the error
 */
export class AssertionError extends MfsFolderError {
    constructor(message, eventName) {
        super(message !== null && message !== void 0 ? message : `Assertion error`, false, eventName !== null && eventName !== void 0 ? eventName : 'AssertionError', MfsStatusCode.NotAllowed);
    }
}
//# sourceMappingURL=assertionError.js.map